import { useCallback } from 'react';
import { useLocation } from 'react-router';

import { useUser } from 'context/userContext';

import { trackKwelloAction } from 'utils/telemetry/telemetry';

const useTrackAction = label => {
  const { userDetails } = useUser();
  const { pathname } = useLocation();

  const trackAction = useCallback(
    data => {
      const [, module, project] = pathname.split('/');

      trackKwelloAction(label, {
        kwelloURL: pathname,
        kwelloModuleName: module,
        kwelloProjectID: project,
        kwelloUserID: userDetails.userId,
        ...data,
      });
    },
    [label, userDetails, pathname],
  );

  return trackAction;
};

export default useTrackAction;
